import moment from 'moment';
import { safeParse } from '../../utils/helpers';
import * as type from '../actions/types';

const initialState = {
  restaurant: {},
  restaurantFetching: true,
  restaurantError: false,
  restaurantErrorMessage: '',
  todayByTimezone: -1,
  linkedVenues: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_RESTAURANT_PENDING:
      return {
        ...state,
        restaurant: {},
        restaurantFetching: true,
        restaurantError: false,
        restaurantErrorMessage: '',
      };
    case type.FETCH_RESTAURANT_SUCCESS: {
      // Parse the hours here, to avoid doing it multiple times in other places
      let hoursParsed = {};
      try {
        hoursParsed = JSON.parse(action.payload?.restaurant?.hours);
      } catch {
        hoursParsed = {};
      }

      const today = moment().startOf('day');
      const obeeIsLive = today >= moment(action.payload?.restaurant?.obeeGoLiveDate);

      return {
        ...state,
        restaurant: {
          ...action.payload.restaurant,
          hoursParsed,
          obeeIsLive,
        },
        todayByTimezone: action.payload.todayByTimezone,
        restaurantFetching: false,
        restaurantError: false,
        restaurantErrorMessage: '',
      };
    }

    case type.FETCH_RESTAURANT_FAILURE:
      return {
        ...state,
        restaurant: {},
        restaurantError: true,
        restaurantErrorMessage: action.payload,
        restaurantFetching: false,
      };

    case type.FETCH_LINKED_VENUES_SUCCESS:
      return {
        ...state,
        linkedVenues: safeParse(action.payload)?.loggedInUser?.venues || [],
      };

    case type.FETCH_LINKED_VENUES_FAILURE:
      return {
        ...state,
        linkedVenues: [],
      };

    default:
      return state;
  }
};
